import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import Items from 'components/Store/Items/Items';

import classes from './DiscoverSection.module.css';

const DiscoverSection = props => {
  const handleChange = newValue => () => {
    props.changeSection(newValue);
  };

  return (
    <div className={classes.section}>
      <div className={classes.typeSectionText}>
        <Button
          component={Link}
          to={`/store/${props.link}`}
          className={classes.btnShowMoreText}
          onClick={handleChange(props.link)}
        >
          {props.title}
        </Button>
        <Button
          component={Link}
          to={`/store/${props.link}`}
          className={classes.btnShowMore}
          onClick={handleChange(props.link)}
        >
          Ver más
        </Button>
      </div>
      {props.items.length > 0 ? (
        <Items itemsCard={props.items} section={props.section} />
      ) : (
        <div className={classes.noInfoContainer}>
          <figure className={classes.imgContainer}>
            <img
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/info.png"
              className={classes.img}
              alt="no_info"
            />
          </figure>
          {props.section === 'book' ? (
            <p className={classes.infoText}>
              No hay <strong>Libros</strong> que se puedan mostrar
            </p>
          ) : (
            <p className={classes.infoText}>
              No hay <strong>Cursos y Diplomados</strong> que se
              puedan mostrar
            </p>
          )}
        </div>
      )}
    </div>
  );
};

DiscoverSection.propTypes = {
  // eslint-disable-next-line react/require-default-props
  title: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  link: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  items: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  section: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  changeSection: PropTypes.func
};

export default DiscoverSection;
